// extracted by mini-css-extract-plugin
export default {"btn":"CiVgQq_tmrvNyslD40aS","plus":"UM9X9VC3l49iQFwOJqNA"};